module.exports = __webpack_public_path__ + "img/diagrama-flujo.fb30c24c.svg";